import React from 'react';
function Icons({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M12 21a9 9 0 100-18 9 9 0 000 18z" />
      <path strokeLinecap="round" d="M9 14c1.5 2.667 4.5 2.667 6 0" />
      <path d="M9.5 10a.5.5 0 100-1 .5.5 0 000 1zM14.5 10a.5.5 0 100-1 .5.5 0 000 1z" />
    </svg>
  );
}

export default Icons;
